import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  IconButton,
  DialogTitle as MuiDialogTitle,
} from '@mui/material';
import { ThemeProvider } from '@material-ui/core/styles';
import CloseIcon from '@mui/icons-material/Close';
import themeIncluia from 'theme/incluia'
import {
  dialogContentSpace,
  dialogActions,
} from './styles/modal';

const DialogTitle = (
  ({ children, classes, onClose, isDelete, isWidgetForm, theme, ...props }) => (
    <MuiDialogTitle {...props}>
      <div style={{display:'flex', justifyContent:'space-between'}}>
        <Typography
          align='left'
          variant='h5'
          style={{marginTop:'5px', fontFamily: 'Raleway'}}
        >
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label='close' onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  )
);

const Modal = ({ open, onClose, title, children, actions, isDelete,
                 isWidgetForm = false,width = 'xs',
                 widthInPixels=null, heightInPixels= null, isUserForm=false }) => {

  return (
    <ThemeProvider theme={themeIncluia}>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={width}
        fullWidth
        aria-labelledby='scroll-dialog-title'
        aria-describedby='scroll-dialog-description'
        PaperProps={{
          style: {
            borderRadius: 28,
            width: widthInPixels,
            height: heightInPixels !== null ? heightInPixels : 'auto',
            maxHeight: heightInPixels !== null ? heightInPixels : 'auto',
            maxWidth: widthInPixels,
          },
        }}
      >
        <DialogTitle isDelete={isDelete} onClose={isWidgetForm ? onClose : false} id='scroll-dialog-title' sx={{ padding: '24px' }}>
          {title}
        </DialogTitle>
        <ThemeProvider theme={themeIncluia}>
          <DialogContent dividers style={{ maxHeight: 580, padding: isUserForm ? 0 : '0px 16px 0px 16px', borderTop: 'none', borderBottom: 'none' }}>
            {children}
          </DialogContent>
        </ThemeProvider>
        <ThemeProvider theme={themeIncluia}>
          <DialogActions style={{padding: isUserForm ? '24px' : '16px 16px'}}>{actions}</DialogActions>
        </ThemeProvider>
      </Dialog>
    </ThemeProvider>
  );
};

export default Modal;
